export const writeToClipboard = data => () => {
  navigator.clipboard.writeText(data).then(() => {});
};

export const isClipboardAvailable = () => {
  return navigator.clipboard !== undefined;
};



// WEBPACK FOOTER //
// ./src/common/clipboardUtils.js